/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MatchModule */

import {
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';

import {
    TlsFingerprintMatchConfigItem,
} from 'ajs/modules/match/factories/tls-fingerprint-match.config-item.factory';

import * as l10n from './tls-fingerprint-match.l10n';
import './tls-fingerprint-match.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Match component for TLS Fingerprint.
 *
 * @author Sarthak Kapoor
 */
@Component({
    selector: 'tls-fingerprint-match',
    templateUrl: './tls-fingerprint-match.component.html',
})
export class TlsFingerprintMatchComponent {
    /**
     * TLS Fingerprint Match message item instance.
     */
    @Input()
    public editable: TlsFingerprintMatchConfigItem;

    /**
     * Match label passed to the MatchWrapperComponent.
     */
    @Input()
    public label: string;

    /**
     * ObjectType passed to the MatchWrapperComponent.
     */
    @Input()
    public objectType: string;

    /**
     * FieldName passed to the MatchWrapperComponent.
     */
    @Input()
    public fieldName: string;

    /**
     * Object Type to be used in template for tooltip.
     * Received as a prop from the Match Adder component.
     */
    @Input()
    public matchObjectType: string;

    /**
     * EventEmitter for removing a match, passed to the MatchWrapperComponent.
     */
    @Output()
    public onRemoveMatch = new EventEmitter<void>();

    public readonly l10nKeys = l10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }

    /**
     * Remove the match. Passed to the MatchWrapperComponent.
     */
    public removeMatch(): void {
        this.onRemoveMatch.emit();
    }
}
